import {
  LastDateTimeRange,
  TimePeriodUnit,
} from '@modules/common/components/DateRangePicker/types';
import dayjs from 'dayjs';
import { LastTimeRange } from 'v2/core/entities';

export const getStartDateForLastDateTimeRange = (
  dateRange: LastDateTimeRange | LastTimeRange,
  timezone: string,
) => {
  switch (dateRange.unit) {
    case TimePeriodUnit.Month:
      return dayjs()
        .tz()
        .subtract(dateRange.value ?? 0, 'month')
        .startOf('month')
        .startOf('date')
        .tz();

    case TimePeriodUnit.Week:
      return dayjs()
        .tz()
        .subtract(dateRange.value ?? 0, 'week')
        .startOf('week')
        .startOf('date')
        .tz();

    case TimePeriodUnit.Day:
      return dayjs()
        .tz()
        .subtract(dateRange.value ?? 0, 'day')
        .startOf('date')
        .tz();

    default:
      return dayjs().tz(); // required for legacy type 'LastTimeRange', but it won't ever run
  }
};
